<template>
    <Layout>
        <div class="static-content" v-html="content"></div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'ContactsPage',
    components: {
        Layout
    },
    data() {
        return {
            content: ''
        };
    },
    created() {
        this.$http.get(`/api/v1/information/tech-contacts/`).then(response => {
            this.content = response.data;
        });
    }
};
</script>
